import React from 'react';

const TermsOfService = () => {
  return (
    <div className="bg-gray-900 min-h-screen text-white p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
        
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Agreement to Terms</h2>
          <p className="mb-4">
            By accessing and using 502 Gold (www.502gold.com), you agree to be bound by these Terms of Service.
            If you disagree with any part of these terms, you may not access our service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Age Restrictions</h2>
          <p className="mb-4">
            You must be at least 18 years old to use this website. By using this service, you warrant and represent
            that you are at least 18 years of age. Any use or access by anyone under 18 is strictly prohibited.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Legal Compliance</h2>
          <p className="mb-4">
            Users must comply with all applicable laws and regulations in their jurisdiction.
            The use of this service is strictly prohibited in regions where online lottery or betting is illegal.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. User Responsibilities</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account</li>
            <li>Not share account credentials</li>
            <li>Report any unauthorized use</li>
            <li>Use the service responsibly and ethically</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Service Modifications</h2>
          <p className="mb-4">
            We reserve the right to modify or discontinue our service at any time without notice.
            We shall not be liable to you or any third party for any modification, suspension, or discontinuance.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Limitation of Liability</h2>
          <p className="mb-4">
            502 Gold shall not be liable for any indirect, incidental, special, consequential, or punitive damages
            resulting from your use or inability to use the service.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Contact Information</h2>
          <p className="mb-4">
            For any questions about these Terms of Service, please contact us at:<br />
            Email: support@502gold.com<br />
            Website: www.502gold.com
          </p>
        </section>

        <footer className="text-sm text-gray-400">
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </footer>
      </div>
    </div>
  );
};

export default TermsOfService; 